import { defineComponent as _defineComponent } from 'vue';
import { SImageLazy } from '@strana-artw/ui-kit';
import { defineComponent, toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { YM_HIDE_CONTENT } from '@/shared/constants';
import { PhoneOutput } from '@/shared/ui/outputs';
export default /*#__PURE__*/_defineComponent({
  __name: 'ManagerInfo',
  props: {
    manager: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'ManagerInfo'
    });
    var _toRefs = toRefs(useScreenPlugin()),
      isMobile = _toRefs.isMobile;
    return {
      __sfc: true,
      isMobile: isMobile,
      SImageLazy: SImageLazy,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT,
      PhoneOutput: PhoneOutput
    };
  }
});